"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useServiceUrlsProvider = void 0;
var _react = require("react");
const useServiceUrlsProvider = ({
  serviceUrls
}) => (0, _react.useMemo)(() => serviceUrls,
// eslint-disable-next-line react-hooks/exhaustive-deps -- Service Urls are not refetched and changed on the client side
[]);
exports.useServiceUrlsProvider = useServiceUrlsProvider;
